var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eyesG",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.33,255.94c0,7.64.11,15.1-.15,22.54-.03.85-2.06,2.29-3.22,2.34-5.6.25-11.21.11-17.25.11v25.02c-5.69,0-10.96.18-16.21-.06-3.58-.17-5.12.85-4.98,4.7.25,6.8.07,13.62.07,20.87h-20.59v25.79h-83.1v-25.48c-5.95,0-11.23-.15-16.5.05-3.61.14-5.13-1.07-5.01-4.86.22-6.79.06-13.6.06-21.06h-20.55v-24.81h-42.59v24.7h-20.75c0,7.35-.21,14.13.08,20.88.18,4.01-1.2,5.33-5.15,5.11-5.12-.29-10.26-.07-16.21-.07v25.61h-82.74v-25.66h-20.86c0-6.95-.23-13.57.08-20.17.2-4.41-1.31-5.92-5.72-5.61-4.96.36-9.97.08-15.58.08v-24.93h-20.62v-25.08h417.49ZM461.24,307.48h20.71v24.73h21.57v-26.27c-5.99,0-11.48-.1-16.97.04-2.98.08-4.16-.99-4.1-4.06.16-6.97.05-13.94.05-21.13h-21.27v26.69h.01ZM251.73,307.27h21.19v24.75h20.78v-26.25h-20.6v-24.94h-21.36v26.44h0Z",
    className: "main-eye-color"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.24,307.48v-26.69h21.27c0,7.19.11,14.16-.05,21.13-.07,3.07,1.12,4.13,4.1,4.06,5.49-.14,10.98-.04,16.97-.04v26.27h-21.57v-24.73h-20.72Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,307.27v-26.44h21.36v24.94h20.6v26.25h-20.78v-24.75h-21.19,0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesG);
export default __webpack_public_path__ + "static/media/eyesG.ef0d93b5fc5018a52cc2413055de5984.svg";
export { ForwardRef as ReactComponent };